import React from 'react';
import merge from 'lodash.merge';

export default defaultProps => BaseComponent => props => <BaseComponent {...merge({}, defaultProps, props)} />;
